import {Product,} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty
} from "@flexinet/ui-components";
import {StatusBadge} from "./StatusBadge.tsx";
import {Stack} from "@mantine/core";
import {FreeTrialBadge} from "./FreeTrialBadge.tsx";


export const InformationPropertyCard = ({record}: { record: Product }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Status',
            value: <StatusBadge status={record.status}/>,
            span: 12,
        }, {
            label: 'Free Trial Available',
            value: <FreeTrialBadge record={record}/>,
            span: 12,
        }
    ] as PlatformPropertyCardProperty[];

    const properties2 = [
        {
            label: 'Short Description',
            value: record.shortDescription as string,
            span: 12,
        }, {
            label: 'Long Description',
            value: record.longDescription as string,
            span: 12,
        }, {
            label: 'Product Image',
            value: record.productImage as string,
            decorator: (value: string) => {
                return value ? <img src={value} alt={'Profile Picture'} style={{maxWidth: '150px'}}/> : value
            },
            span: 12,
        }
    ] as PlatformPropertyCardProperty[];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
